<template>
  <v-card class="back" style="height: 480px">
    <v-layout column fill-height>
      <v-toolbar dark color="secondary" dense flat>
        <v-toolbar-title>
          <span class="body-2 text-uppercase">{{$t('change password for user')}} {{getUser.login}}?</span>
        </v-toolbar-title>
      </v-toolbar>

      <scroll-area>
        <template slot="body">
          <v-layout column fill-height justify-start>

            <v-flex shrink pa-2>
              <v-text-field
                v-model="curPass"
                :data-testid="$options.name + '__text-field__' + 'current_password'"
                light
                auto-grow
                flat
                :rules="[value => !!value || $t('this field is required')]"
                validate-on-blur
                :label="$t('enter current password') + ' *'"
                hint
                class="white"
                background-color="white"
                rows="1"
                @click:append="() => (curPassVisible = !curPassVisible)"
                :append-icon="curPassVisible ? 'visibility' : 'visibility_off'"
                :type="curPassVisible ? 'text' : 'password'"
              ></v-text-field>
            </v-flex>

            <v-flex shrink pa-2>
              <v-text-field
                v-model="newPass"
                :data-testid="$options.name + '__text-field__' + 'new_password'"
                light
                auto-grow
                flat
                :rules="[value => !!value || $t('this field is required'), value => value != curPass || $t('Новый пароль должен отличаться от текущего')]"
                validate-on-blur
                :label="$t('enter new password') + ' *'"
                hint
                class="white"
                background-color="white"
                rows="1"
                @click:append="() => (newPassVisible = !newPassVisible)"
                :append-icon="newPassVisible ? 'visibility' : 'visibility_off'"
                :type="newPassVisible ? 'text' : 'password'"
              ></v-text-field>
            </v-flex>

            <v-flex shrink pa-2>
              <v-text-field
                v-model="checkPass"
                :data-testid="$options.name + '__text-field__' + 'check_password'"
                light
                auto-grow
                flat
                :rules="[value => !!value || $t('this field is required'), value => value == newPass || $t('new password mismatch')]"
                :label="$t('repeat new password') + ' *'"
                class="white"
                background-color="white"
                rows="1"
                @click:append="() => (checkPassVisible = !checkPassVisible)"
                :append-icon="checkPassVisible ? 'visibility' : 'visibility_off'"
                :type="checkPassVisible ? 'text' : 'password'"
              ></v-text-field>
            </v-flex>

          </v-layout>

        </template>

        <template slot="footer">
          <v-layout fill-height>
            <v-flex xs2>
            </v-flex>

            <v-layout fill-height justify-end>             
              <v-btn  dark small color="primary"
                :disabled="checkDisabled" 
                :data-testid="$options.name + '__btn__' + 'save'"
                @click="changePass">
                  {{$t('save')}}
                </v-btn>
              <v-btn dark small color="secondary"
                :data-testid="$options.name + '__btn__' + 'cancel'"
                @click="$emit('close')">
                {{$t('cancel')}}
              </v-btn>

            </v-layout>
          </v-layout>
        </template>

      </scroll-area>

    </v-layout>

  </v-card>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы
interface UserData {
  login?: string
  [key: string]: any
}

interface ChildItem {
  name?: string
  [key: string]: any
}

interface CmdbQueryResponse {
  children?: ChildItem[]
  [key: string]: any
}

interface UserUpdateData {
  oldPassword: string | null
  password: string | null
}

export default Vue.extend({
  name: 'CHANGE_PASS_CARD',

  components: {
    scrollArea,
  },

  props: {},

  data(): {
    user: UserData | null
    curPass: string | null
    curPassVisible: boolean
    newPass: string | null
    newPassVisible: boolean
    checkPass: string | null
    checkPassVisible: boolean
  } {
    return {
      user: null,
      curPass: null,
      curPassVisible: false,
      newPass: null,
      newPassVisible: false,
      checkPass: null,
      checkPassVisible: false,
    }
  },

  computed: {
    getUser(): UserData | null {
      return this.user
    },

    checkDisabled(): boolean {
      let disabled = true
      if (this.curPass && this.newPass && this.checkPass && 
          this.newPass !== this.curPass && this.newPass === this.checkPass) {
        disabled = false
      }
      return disabled
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadUser()
    },

    async loadUser(): Promise<void> {
      const store = this.$store.state as any
      this.user = store.auth.user
      // console.log(this.$options.name, 'loadUser', 'this.user', this.user)
    },

    async changePass(): Promise<void> {
      try {
        // const query = {
        //   id: ['/catalogs/user'],
        //   notNull: true,
        //   data: {
        //     namePath: true,
        //     children: { flatten: true }
        //   }
        // }
        // const users = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        
        const users = await this.$bridge.getAllUsers()

        if (users?.length) {
          const user = users.find(child => child.name === this.user?.login)
          console.log(this.$options.name, 'changePass', 'this.user.login', this.user.login)
          console.log(this.$options.name, 'changePass', 'user', user)
        // if (users?.[0]?.children) {
        //   const user = users[0].children.find(child => child.name === this.user?.login)
          
          if (user) {
            // const data$: UserUpdateData = {
            //   oldPassword: this.curPass,
            //   password: this.newPass
            // }
            // const updated = await user.update(data$)
            const updated = await this.$bridge.changePassword(this.curPass, this.newPass)
            
            if (updated) {
              this.$dialog.notify.success(this.$getTranslate('password changed successfully'), {
                timeout: 5000
              })
              setTimeout(() => this.$emit('close'), 300)
            } else {
              this.$dialog.notify.error('Ошибка изменения пароля', {
                timeout: 5000
              })
              console.error('CATCH', 'change-pass-card', 'changePass', 'smth wrong')
            }
          }
        }
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', 'change-pass-card', 'changePass', err)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
